import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, ViewChild, Inject, Component, NgModule } from '@angular/core';
import { each } from 'lodash';

/**
 * CONFIGURATION
 *
 * @description Token donde se almacenara toda la informacion de los contentidos estaticos
 */
const CONFIGURATION = new InjectionToken('CONFIGURATION');

/**
 * loadScript
 *
 * @description Metodo para cargar los script de forma remota
 * @param urlResource - Url del archivo a cargar
 * @param container - Elemento donde se cargara el script
 */
function loadScript(urlResource, container, module, nomodule) {
    const script = document.createElement('script');
    if (nomodule) {
        script.noModule = true;
    }
    else {
        script.type = module ? 'module ' : 'text/javascript';
    }
    script.src = urlResource;
    container.appendChild(script);
}
/**
 * loadStylesheet
 *
 * @description Metodo para cargar hojas de estilos de forma remota
 * @param urlResource - Url del archivo a cargar
 * @param container - Elemento donde se cargara el script
 */
function loadStylesheet(urlResource, container) {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = urlResource;
    container.appendChild(stylesheet);
}

class ExternalAccessComponent {
    constructor(configuration) {
        this.configuration = configuration;
    }
    ngOnInit() {
        each(this.configuration, (element) => {
            if (element.type === 'stylesheet') {
                loadStylesheet(element.url, this.container.nativeElement);
            }
            else if (element.type === 'javascript') {
                loadScript(element.url, this.container.nativeElement, element.module, element.nomodule);
            }
        });
    }
    ngOnDestroy() {
        this.container.nativeElement.innerHTML = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalAccessComponent, deps: [{ token: CONFIGURATION }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ExternalAccessComponent, selector: "external-assets", viewQueries: [{ propertyName: "container", first: true, predicate: ["slot"], descendants: true, static: true }], ngImport: i0, template: `<div #slot></div>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalAccessComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'external-assets',
                    template: `<div #slot></div>`,
                }]
        }], ctorParameters: () => [{ type: Array, decorators: [{
                    type: Inject,
                    args: [CONFIGURATION]
                }] }], propDecorators: { container: [{
                type: ViewChild,
                args: ['slot', { static: true }]
            }] } });

class ExternalAssetsModule {
    static forRoot(config) {
        return {
            ngModule: ExternalAssetsModule,
            providers: [
                {
                    provide: CONFIGURATION,
                    useValue: config,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalAssetsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ExternalAssetsModule, declarations: [ExternalAccessComponent], imports: [CommonModule], exports: [ExternalAccessComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalAssetsModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalAssetsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ExternalAccessComponent],
                    imports: [CommonModule],
                    exports: [ExternalAccessComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ExternalAccessComponent, ExternalAssetsModule };
